let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8xDY5")).then(() => parcelRequire('b4bKO'));